import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged, fromEvent, map, scan, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingScreenService {
  get isLoadingScreenVisible(): boolean {
    return this._isLoadingScreenVisible;
  }

  get isLoadingScreenVisible$(): Observable<boolean> {
    return this._showRequestCountSubject.asObservable().pipe(
      scan((acc, value) => Math.max(0, acc + value), 0),
      map(count => count > 0),
      tap(isVisible => (this._isLoadingScreenVisible = isVisible)),
      distinctUntilChanged(),
    );
  }

  private _showRequestCountSubject = new BehaviorSubject<number>(0);
  private _isLoadingScreenVisible = false;

  constructor() {
    fromEvent(window, 'offline').subscribe(() => this._showRequestCountSubject.next(-1000));
  }

  showLoadingScreen(): void {
    this._showRequestCountSubject.next(1);
  }

  hideLoadingScreen(): void {
    this._showRequestCountSubject.next(-1);
  }

  async run<T>(action: () => T | Promise<T>): Promise<T> {
    this.showLoadingScreen();
    try {
      return await action();
    } finally {
      this.hideLoadingScreen();
    }
  }
}
